import { render } from "./ProductHistory.vue?vue&type=template&id=8d1f77c2&scoped=true"
import script from "./ProductHistory.vue?vue&type=script&lang=js"
export * from "./ProductHistory.vue?vue&type=script&lang=js"

import "./ProductHistory.vue?vue&type=style&index=0&id=8d1f77c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d1f77c2"]])

export default __exports__